module.exports = __webpack_public_path__ + "img/remove_circle_icon.edf51d68.svg";